/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { TouchableOpacity } from 'react-native';
import Image from '@components/global/Image';

const ActionButton = ({ icon, onCallback }) => {
  return (
    <TouchableOpacity style={{ paddingHorizontal: 15 }} onPress={onCallback}>
      <Image
        width={20}
        height={20}
        style={{ width: 20, height: 20 }}
        svg={true}
        source={icon}
      />
    </TouchableOpacity>
  );
};

export default React.memo(ActionButton, (prev, next) => prev == next);
